import Vue  from 'vue'
import WriteReceiver from '@/modules/mail/components/Write/WriteReceiver.vue'
import WriteTitle from '@/modules/mail/components/Write/WriteTitle.vue'
import WriteAttachment from '@/modules/mail/components/Write/WriteAttachment.vue'
import WriteBody from '@/modules/mail/components/Write/WriteBody.vue'
import WriteCC from '@/modules/mail/components/Write/WriteCC.vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import mailApi from '@mail/api'
import * as accountTypes from '@account/store/types'
import * as orgTypes from '@orgmap/store/types'
import { mapGetters, mapMutations } from 'vuex'
import { createEventBus, removeEventBus } from '@/util'
import * as dateutil from '@appbase/util/date-helper'

@Component({
  components: {
    WriteTitle,
    WriteReceiver,
    WriteCC,
    WriteBody,
    WriteAttachment
  },
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    })
  },
  methods: {
    ...mapMutations({
      userListClear: orgTypes.ORG_USER_SELECT_CLEAR
    }),
  }
})
export default class WriteContainer extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Array }) toWhom?: Array<mail.RecipientTag>
  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //
  openWriteCC: boolean = false
  loaded: boolean = false

  email: mail.WriteEmailData = ({
    subject: '',
    to: [],
    cc: [],
    bcc: [],
    body: '',
    attachments: '',
    isBigfile: false,
    isDraft: false,
    id: null,
    method: null,
    code: '',
    codeValues: [],
    importance: 'Normal',
    security: 'Normal',
    whenToSend: '',
  } as unknown) as mail.WriteEmailData

  currentMenuId: number = 0
  currentBoard: number = 0
  currentArticle: number = 0

  sender: string = ''
  title: string = ''
  content: string = ''
  fileCode: string = ''
  uploadState: string = ''

  /**
   * 임시저장 아이디
   * 임시저장된 메일을 열거나,
   * 회신, 전체회신, 전달 메일 작성 중 임시저장 완료된 경우 존재함
   */
  draftId: string | null = null

  /**
   * 메일 작성이 열리고 수정되었는지 여부
   */
    isChanged: boolean = false

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  user!: account.User

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  userListClear!: () => void

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: W A T C H E S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  @Watch('email.subject')
  onEmailSubjectChanged() {
    this.change()
  }

  @Watch('email.to.length')
  onEmailToChanged() {
    this.change()
  }

  @Watch('email.cc.length')
  onEmailCcChanged() {
    this.change()
  }

  @Watch('email.bcc.length')
  onEmailBccChanged() {
    this.change()
  }
  
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  showWriteCC(show: boolean) {
    this.openWriteCC = show
  }

  /**
   * 메시지 임시저장 후 URL에 DraftId를 업데이트합니다.
   * 페이지 새로고침 없이 히스토리를 수정합니다.
   * @param id item id
   */
   invalidateBrowserHistoroy(id: string) {
    console.log('replace history', window.history.state)
    this.$route.query.id = id
    this.email.id = id
    const url = this.$route.path + `?id=${encodeURIComponent(id)}`
    window.history.replaceState(null, '', url)
  }

  async load() {
    const id = this.$route.query.id as string
    const type = this.$route.query.type as 're' | 'reall' | 'fw' | 'draft'
    // if (['re', 'reall', 'fw'].includes(type)) {
    //   api.email.getAutoForwardInfo(originId).then((item) => {
    //     // temp 에서 기존 메시지를 복제하기 때문에 파일 코드를 새로 생성한다
    //     api.email.temp(originId, this.createAttachmentCode(), type).then((tempid) => {
    //       // URL을 temp에 있는 아이템 대상으로 변경
    //       this.invalidateBrowserHistoroy(tempid)
    //       // 메시지 상세 로드
    //       loadEmail(tempid, item.autofw)
    //         .then(ensureAttachCode)
    //         .then(() => {
    //           this.setLoading(false)
    //         })
    //         .catch(() => this.setLoading(false))
    //     })
    //   })}
    if (id) {
      const data = this.email
      // 회신, 전체회신, 전달, draft인 경우 id가 전달됨
      try {
        const tempId = await mailApi.mail.temp(id, this.createAttachmentCode(), type)
        const [email, body] = await Promise.all([
          mailApi.mail.getDetail(tempId),
          mailApi.mail.getBody(tempId),
        ]).then()
        this.invalidateBrowserHistoroy(tempId)
        this.buildBody(email, body)
        this.buildEmail(email)
        this.email.isDraft = true
      } catch (e) {
        console.log(e)
      }
    } else {
      this.email.body = ''
    }
    const uid = `uid-${Date.now()}`
    this.email.code = `MAIL_${this.user.id}_${uid}`
    this.email.codeValues = ['Mail', this.user.comCode, dateutil.uGetDateFormat('yyyyMM', new Date()), uid]
    this.loaded = true
  }

  createAttachmentCode() {
    const uid = `uid-${Date.now()}`
    const code = `MAIL_${this.user.id}_${uid}`
    // console.log('mail-write', 'createAttachmentCode', code)
    return code
  }

  buildEmail(email: mail.EmailMessage) {
    const type = this.$route.query.type as 're' | 'reall' | 'fw' | 'draft'
    const data = this.email
    const from: mail.RecipientTag = {
      text: email.from.name,
      value: email.from.address,
    }
    const convert = function(list?: mail.EwsRecipient[]) {
      return (
        list?.map((r) => ({
          text: r.name,
          value: r.address,
        })) || []
      )
    }
    const buildSubject = function(subject: string, prefix: string) {
      if (
        !subject
          .toLowerCase()
          .trim()
          .startsWith(`${prefix}`)
      ) {
        return `${prefix.toUpperCase()} ${subject}`
      } else {
        return subject
      }
    }
    const getTo = () => {
      const result = [from, ...convert(email.to)].filter((r) => r.value !== this.user.email)
      if (result.length > 0) return result
      return [from]
    }
    switch (type) {
      case 're':
        data.to = getTo()
        data.cc = []
        data.bcc = []
        data.subject = buildSubject(email.subject, 're')
        break

      case 'reall':
        // 받는사람 목록에서 자신은 제외
        data.to = getTo()
        if ((data.cc = convert(email.cc)).length > 0) {
          this.openWriteCC = true
        }
        data.bcc = []
        data.subject = buildSubject(email.subject, 're')
        break

      case 'fw':
        data.to = []
        data.cc = []
        data.bcc = []
        data.subject = buildSubject(email.subject, 'fw')
        break

      case 'draft':
        data.to = convert(email.to)
        data.cc = convert(email.cc)
        data.bcc = convert(email.bcc)
        data.subject = buildSubject(email.subject, '')
        break

      default:
        data.subject = email.subject
        break
    }
  }

  buildBody(email: mail.EmailMessage, body: string) {
    if (email.isDraft === 'True') {
      this.draftId = email.id
      body = '<br>' + body
    } else {
      var alter = this.getBodyHeadRawHtml(email)
      // 메일 헤더 정보와 실제 본문을 합쳐서 body 설정
      var match = /<body.*?>/.exec(body)
      if (match) {
        // HTML Body
        var position = match.index + match[0].length
        body = body.slice(0, position) + alter + body.slice(position + 1)
      } else {
        // Text Body
        var ps = body.split('\n')
        body = ps
          .map(function(value) {
            return '<p>' + value + '</p>'
          })
          .join('')
        body = '<html><head></head><body>' + alter + body + '</body></html>'
      }
    }
    this.email.body = body
  }

  getBodyHeadRawHtml(email: mail.EmailMessage) {
    const converRcptString = function(rcpts: mail.EwsRecipient[]) {
      return rcpts.map((r) => `${r.name}&lt;${r.address}&gt;`).join(';')
    }
    return `
<br />
<br />
<div>
<div
    style="border:none;border-top:solid #E1E1E1 1.0pt;padding:3.0pt 0cm 0cm 0cm"
>
    <p class="MsoNormal">
        <span style='font-size:11.0pt;font-family:"Calibri",sans-serif'>
            <b>From:</b>
        </span>
        <span lang="KO" style="font-size:11.0pt">
            ${email.from.name}&lt;${email.from.address}&gt;
        </span>

        <span style='font-size:11.0pt;font-family:"Calibri",sans-serif'>
            <br />
            <b>Sent:</b> ${email.dateTimeCreated}
        </span>

        <span style='font-size:11.0pt;font-family:"Calibri",sans-serif'>
            <br />
            <b>To:</b>
        </span>
        ${converRcptString(email.to || [])}
        <span style='font-size:11.0pt;font-family:"Calibri",sans-serif'>
            <br />
            <b>To:</b>
        </span>
        ${converRcptString(email.cc || [])}
        <span style="font-size:11.0pt;font-family:'Calibri',sans-serif">
            <br />
            <b>Subject:</b>
        </span>
        <span lang="KO" style="font-size:11.0pt">${email.subject}</span>
    </p>
</div>
</div>
<br />`
  }

  update(email: mail.WriteEmailData) {
    this.email = email
  }

  validateEmail(value: string): any {
    const emailRegex = new RegExp(`^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$`)

    if (!emailRegex.test(value) && value.length > 0) {
      return { succeed: false, reason: 'invalid' }
    } else if (!value) {
      return { succeed: false, reason: 'blank' }
    } else {
      return { succeed: true }
    }
  }

  async send(
    saveMethod: 'save' | 'draft' = 'save',
    sendMethod: 'new' | 're' | 'reall' | 'fw' | 'draft' = 'new',
    importance: 'Low' | 'Normal' | 'High' = 'Normal'
  ): Promise<string> {
    this.invokeEditorEmitManually();
    var allrcpts = this.email.to.concat(this.email.cc).concat(this.email.bcc)
    //
    // 메일주소 유효성 검사
    //
    for (var i = 0; i < allrcpts.length; i++) {
      let szSmtpAddress = allrcpts[i].value || ''
      let result = this.validateEmail(szSmtpAddress)
      if (result.succeed === false) {
        if (result.reason === 'invalid') {
        } else if (result.reason === 'blank') {
          await(window as any).alertAsync(this.$t('M_Settings_Msg1').toString() + ` [${allrcpts[i].text}]`)
        }
        return Promise.resolve('')
      }
    }
    //
    // 제목 유효성 검사
    //
    if (saveMethod === 'save') {
      if (this.email.to.length <= 0) {
        await(window as any).alertAsync(this.$t('M_Mail_Msg8').toString())
        return Promise.resolve('')
      }
      if (!this.email.subject) {
        await(window as any).alertAsync(this.$t('M_Mail_Msg9').toString())
        return Promise.resolve('')
      }
    }
    //
    // 첨부 업로드 중에는 메일 발송 제한
    //
    if (this.uploadState === 'uploading') {
      await(window as any).alertAsync(this.$t('M_Mail_SendErrorUploadState').toString())
      return Promise.resolve('')
    }

    if (!saveMethod) {
      saveMethod = 'save'
    }
    const { email: data } = this
    const convertToRecipient = (r: mail.RecipientTag) => ({ address: r.value } as mail.EwsRecipient)
    //const convertToRecipient = (r: any) => ({ address: r.email } as any);
    const email: mail.EmailSendRequest = {
      key: data.code,
      subject: data.subject,
      id: this.$route.query.id as string,
      draftId: undefined,//this.draftId || undefined,
      to: data.to.map((d) => convertToRecipient(d)),
      cc: data.cc.map((d) => convertToRecipient(d)),
      bcc: data.bcc.map((d) => convertToRecipient(d)),
      body: data.body,
      saveMethod: saveMethod,
      sendMethod: sendMethod,
      // attachments
      importance: data.importance,
      isBigfile: data.isBigfile,
      attachmentFileCode: data.code,
    }
    if (data.isDraft) {
      email.draftId = this.draftId as string
    } else {
      email.id = data.id
    }
    var request = mailApi.mail.send(email).then((draftId) => {
      this.draftId = draftId
      return draftId
    })

    if (sendMethod !== 'draft') {
      this.close()
    }
    return request
  }

  change(changed: boolean = true) {
    if (this.loaded) {
      this.isChanged = changed
    }
  }

  async cancel() {
    if (this.isChanged) {
      const message = this.$t('임시_저장을_하시겠습니까').toString()
      if (await(window as any).confirmAsync(message) == false) {
        this.close()
      } else {
        this.save()
          .then(async (draftId) => {
            if (draftId) {
              await(window as any).alertAsync(this.$t('M_Mail_DraftNotify').toString())
            } else {
              await(window as any).alertAsync(this.$t('M_Mail_DraftErrorNotify').toString())
            }
          })
          .then(() => {
            this.close()
          })
      }
    } else {
      this.close()
    }
  }

  save(): Promise<string> {
    return this.send('draft', 'draft')
  }

  close() {
    this.userListClear()
    this.$router.back()
  }

  scrollToTop() {
    ;((this.$refs.writeView as any) || {}).scrollTop = 0
  }

  /**
   * 모바일에서는 보내기 버튼 터치 시 작성한 본문을 못가져오는 문제가 있음
   * 에디터에서 포커스가 빠졌을때 $emit('input')하게 되는데 터치에는
   * focus blur 이벤트가 발생 안하는 경우가 있다.
   * 수동으로 이러한 동작을 발생시킨다.
   */
  invokeEditorEmitManually() {
    const body = this.$refs.body as any
    body.emitInput()
  }

  attach(){
    (this.$refs.writeAttachment as any).attach()
  }

  uploadStateChanged(state: string) {
    this.uploadState = state
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  mounted() {
    if (this.$route.query.uid) {
      this.email.to = [
        {
          text: this.$route.query.uid + '',
          value: this.$route.query.uid + '',
        },
      ]
    }
  }

  created() {
    createEventBus(window, 'mail-close', this.cancel)
    this.scrollToTop()
    if (this.email.cc.length || this.email.bcc.length) {
      this.openWriteCC = true
    }
    this.load()
  }

  beforeDestroy() {
    removeEventBus(window, 'mail-close', this.cancel)
  }
}
